import { createAction } from 'redux-act';

export const saveRating = createAction();
export const ratingSaved = createAction();

export const onError = createAction();

export const getRatingsByProgram = createAction();
export const programRatingsReceived = createAction();
